import React, { useState } from 'react';

/**
 * Chip picker with a constrained dropdown instead of free-text input.
 * `normalizeFn` maps identities for the remaining-options filter — e.g. a
 * legacy-cased stored 'ASCVD' chip must hide its canonical twin.
 */
export default function ConstrainedChips({ items, options, onChange, labelFn, normalizeFn, chipBg, chipColor, placeholder }) {
  const [open, setOpen] = useState(false);
  const bg = chipBg || 'var(--wi-background-tertiary)';
  const color = chipColor || 'var(--wi-text-primary)';
  const label = labelFn || (v => v.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase()));
  const idOf = normalizeFn ? (v => normalizeFn(v) ?? String(v).toLowerCase()) : (v => v);
  const remaining = options.filter(o => !items.some(i => idOf(i) === idOf(o)));

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
      {items.map((item, i) => (
        <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 6, background: bg, color, fontSize: 13 }}>
          {label(item)}
          <button onClick={() => onChange(items.filter((_, j) => j !== i))} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: 'var(--wi-text-secondary)', padding: 0, lineHeight: 1 }}>×</button>
        </span>
      ))}
      {remaining.length > 0 && (
        open ? (
          <select
            autoFocus
            value=""
            onChange={e => { if (e.target.value) { onChange([...items, e.target.value]); setOpen(false); } }}
            onBlur={() => setOpen(false)}
            style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid var(--wi-divider)', fontSize: 13, fontFamily: 'var(--wi-font-family)', outline: 'none', background: 'var(--wi-background-secondary)', color: 'var(--wi-text-primary)', cursor: 'pointer' }}
          >
            <option value="">{placeholder || 'Select...'}</option>
            {remaining.map(o => <option key={o} value={o}>{label(o)}</option>)}
          </select>
        ) : (
          <button onClick={() => setOpen(true)} style={{ background: 'none', border: '1px dashed var(--wi-divider)', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 12, color: 'var(--wi-text-secondary)', fontFamily: 'var(--wi-font-family)' }}>+ Add</button>
        )
      )}
    </div>
  );
}
